"use strict";
const disableScroll = () => {
  document.documentElement.style.overflow = "hidden";
  document.body.style.overflow = "hidden";
};
const enableScroll = () => {
  document.documentElement.style.overflow = "";
  document.body.style.overflow = "";
};
export { disableScroll, enableScroll };
